//Generated File 
export default class KeyboardKey{
	static readonly A = `A`;
	static readonly ArrowDown = `ArrowDown`;
	static readonly ArrowLeft = `ArrowLeft`;
	static readonly ArrowRight = `ArrowRight`;
	static readonly ArrowUp = `ArrowUp`;
	static readonly B = `B`;
	static readonly Backspace = `Backspace`;
	static readonly C = `C`;
	static readonly D = `D`;
	static readonly Delete = `Delete`;
	static readonly E = `E`;
	static readonly End = `End`;
	static readonly Enter = `Enter`;
	static readonly Esc = `Esc`;
	static readonly F = `F`;
	static readonly F1 = `F1`;
	static readonly F10 = `F10`;
	static readonly F11 = `F11`;
	static readonly F12 = `F12`;
	static readonly F2 = `F2`;
	static readonly F3 = `F3`;
	static readonly F4 = `F4`;
	static readonly F5 = `F5`;
	static readonly F6 = `F6`;
	static readonly F7 = `F7`;
	static readonly F8 = `F8`;
	static readonly F9 = `F9`;
	static readonly G = `G`;
	static readonly H = `H`;
	static readonly Home = `Home`;
	static readonly I = `I`;
	static readonly Insert = `Insert`;
	static readonly J = `J`;
	static readonly K = `K`;
	static readonly L = `L`;
	static readonly M = `M`;
	static readonly N = `N`;
	static readonly O = `O`;
	static readonly P = `P`;
	static readonly PageDown = `PageDown`;
	static readonly PageUp = `PageUp`;
	static readonly Q = `Q`;
	static readonly R = `R`;
	static readonly S = `S`;
	static readonly T = `T`;
	static readonly U = `U`;
	static readonly V = `V`;
	static readonly W = `W`;
	static readonly X = `X`;
	static readonly Y = `Y`;
	static readonly Z = `Z`;
}
